import { render } from "./GroSpinner.vue?vue&type=template&id=6e3a1538"
import script from "./GroSpinner.vue?vue&type=script&lang=js"
export * from "./GroSpinner.vue?vue&type=script&lang=js"
script.render = render

export default script